/* ==========================================================================
   Gooey Double Label  —  behaviour  (overlay version)
   Turns

       <div class="gooey-double"><span>★★★★★</span><span>Anna R.</span></div>

   into the two-lobe "gooey" silhouette from blank.svg: a left pill and a right
   pill joined by a fixed pinched neck. Each lobe shows the *actual* contents of
   its <span> (text, inline SVG icons/stars, <img>, anything) laid over the
   shape, and auto-sizes to that content. Only the flat top/bottom edges of each
   pill stretch, so the rounded caps and the neck keep their exact shape.

   Usage:
     <link rel="stylesheet" href="gooey-double.css">
     <script src="gooey-double.js"></script>

     <div class="gooey-double">
       <span class="wsh-stars"><svg>…</svg><svg>…</svg></span>  <!-- left lobe  -->
       <span>Anna R.</span>                                     <!-- right lobe -->
     </div>

   FIRST span = left lobe, SECOND span = right lobe.

   Auto-runs on DOMContentLoaded. After adding labels dynamically:
     GooeyDouble.upgradeAll();           // upgrade any new .gooey-double
     new GooeyDouble(element);           // upgrade one element
     GooeyDouble.refresh();              // re-layout all (resize / font / content)
     instance.setContent("L", "<svg…>"); // replace a label (text or HTML)

   Colours / size / font come from CSS variables — see the CSS.
   ========================================================================== */
(function (global) {
  "use strict";

  var SVGNS = "http://www.w3.org/2000/svg";

  /* The silhouette from blank.svg (viewBox 0 0 312 29). Two lobes + neck. */
  var ORIG_PATH =
    "M14.4902 0.5H103.179C108.169 0.500165 112.553 3.11771 115.027 7.05762C116.578 9.52679 119.337 10.953 122.229 10.9531H126.373C129.339 10.953 132.06 9.40733 133.658 6.92285C134.199 6.08177 134.828 5.30282 135.531 4.59961C138.064 2.06579 141.562 0.5 145.424 0.5H297.219C304.891 0.5 311.338 6.54982 311.497 14.1982C311.58 18.1808 310 21.7958 307.402 24.4004C304.87 26.9342 301.372 28.5 297.51 28.5H145.424C140.61 28.5 136.36 26.0649 133.844 22.3535C132.27 20.0322 129.598 18.7207 126.818 18.7207H121.639C118.828 18.7207 116.272 20.1698 114.688 22.4619C114.208 23.1561 113.666 23.8047 113.07 24.4004C110.538 26.9341 107.04 28.4999 103.179 28.5H14.7871C7.11468 28.5 0.665684 22.4517 0.50293 14.8027C0.418141 10.8175 1.99868 7.19991 4.59766 4.59961C7.13012 2.06581 10.6283 0.5 14.4902 0.5Z";

  /* x break-points along the original path */
  var VB_H   = 29,
      MAXX   = 312,
      B0X    = 14.7871,   // left cap  -> left flat
      B1X    = 103.179,   // left flat -> neck
      B2X    = 145.424,   // neck      -> right flat
      B3X    = 297.219,   // right flat-> right cap
      LFLAT0 = B1X - B0X,
      RFLAT0 = B3X - B2X,
      NECKW0 = B2X - B1X,
      RCAP0  = MAXX - B3X,
      PADF     = 0.06,    // default horizontal padding per side, × height
      MINFLATF = 0.22;    // minimum flat width, × height

  var TOKEN_RE = /[MLHVCSQTAZ]|-?\d*\.?\d+(?:e-?\d+)?/gi;
  var SPEC = { M:["x","y"], L:["x","y"], H:["x"], V:["y"],
               C:["x","y","x","y","x","y"], S:["x","y","x","y"],
               Q:["x","y","x","y"], T:["x","y"],
               A:["o","o","o","o","o","x","y"], Z:[] };

  function remapPath(L) {
    var sy = L.sy, lF = L.leftFlatW, rF = L.rightFlatW,
        B0 = L.B0, B1 = L.B1, B2 = L.B2, B3 = L.B3;
    function fx(x) {
      if (x <= B0X) return x * sy;
      if (x <= B1X) return B0 + (x - B0X) / LFLAT0 * lF;
      if (x <= B2X) return B1 + (x - B1X) * sy;
      if (x <= B3X) return B2 + (x - B2X) / RFLAT0 * rF;
      return B3 + (x - B3X) * sy;
    }
    function fy(y) { return y * sy; }

    var toks = ORIG_PATH.match(TOKEN_RE), out = [], i = 0, cmd;
    while (i < toks.length) {
      var t = toks[i];
      if (SPEC[t.toUpperCase()] !== undefined) {
        cmd = t.toUpperCase(); out.push(t); i++;
        if (cmd === "Z") continue;
        var types = SPEC[cmd];
        while (i < toks.length && !/^[MLHVCSQTAZ]$/i.test(toks[i])) {
          for (var k = 0; k < types.length; k++) {
            var ty = types[k], raw = toks[i]; i++;
            if (ty === "x")      out.push(fx(parseFloat(raw)).toFixed(3));
            else if (ty === "y") out.push(fy(parseFloat(raw)).toFixed(3));
            else                 out.push(raw);
          }
        }
      } else { i++; }
    }
    return out.join(" ");
  }

  function el(name, attrs) {
    var e = document.createElementNS(SVGNS, name);
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }

  function GooeyDouble(node) {
    if (!node || node.__gooeyDouble) return node && node.__gooeyDouble;
    this.node = node;
    node.__gooeyDouble = this;

    var spans = [];
    for (var i = 0; i < node.children.length; i++) {
      if (node.children[i].tagName === "SPAN") spans.push(node.children[i]);
    }
    this.slotL = spans[0] || null;
    this.slotR = spans[1] || null;
    if (this.slotL) this.slotL.classList.add("gd-slot", "gd-left");
    if (this.slotR) this.slotR.classList.add("gd-slot", "gd-right");

    this.syncAria();
    this.build();
    this.measureAndLayout();
    node.classList.add("gd-ready");
    GooeyDouble._all.push(this);
  }

  GooeyDouble.prototype.syncAria = function () {
    if (this.node.getAttribute("aria-label")) return;
    function lbl(s) { return s ? (s.getAttribute("aria-label") || s.textContent || "").trim() : ""; }
    var a = (lbl(this.slotL) + " " + lbl(this.slotR)).trim();
    if (a) this.node.setAttribute("aria-label", a);
  };

  GooeyDouble.prototype.build = function () {
    // shape sits behind the spans
    var svg = el("svg", { xmlns: SVGNS, "aria-hidden": "true", class: "gd-shape" });
    this.svg = svg;
    this.fillPath = el("path", { class: "gd-fill" });
    this.strokePath = el("path", { class: "gd-stroke" });
    svg.appendChild(this.fillPath);
    svg.appendChild(this.strokePath);
    this.node.insertBefore(svg, this.node.firstChild);
  };

  GooeyDouble.prototype.cssNum = function (name, fallback) {
    var v = getComputedStyle(this.node).getPropertyValue(name);
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  };

  /* natural rendered width of a slot's content (works for text, svg, img) */
  function contentWidth(slot) {
    if (!slot) return 0;
    var prev = slot.getAttribute("style") || "";
    slot.style.position = "absolute";
    slot.style.left = "-9999px";
    slot.style.top = "0";
    slot.style.display = "inline-flex";
    slot.style.alignItems = "center";
    slot.style.whiteSpace = "nowrap";
    slot.style.visibility = "hidden";
    slot.style.transform = "none";
    var w = slot.getBoundingClientRect().width;
    slot.setAttribute("style", prev);
    return w;
  }

  GooeyDouble.prototype.measureAndLayout = function () {
    var H  = this.cssNum("--gd-height", 30);
    var sy = H / VB_H;

    var lw = contentWidth(this.slotL);
    var rw = contentWidth(this.slotR);

    var pad     = this.cssNum("--gd-pad-x", H * PADF);
    var minFlat = H * MINFLATF;
    var leftFlatW  = Math.max(lw + 2 * pad, minFlat);
    var rightFlatW = Math.max(rw + 2 * pad, minFlat);

    var B0 = B0X * sy;
    var B1 = B0 + leftFlatW;
    var B2 = B1 + NECKW0 * sy;
    var B3 = B2 + rightFlatW;
    var W  = B3 + RCAP0 * sy;

    var d = remapPath({ sy: sy, leftFlatW: leftFlatW, rightFlatW: rightFlatW,
                        B0: B0, B1: B1, B2: B2, B3: B3 });

    this.svg.setAttribute("width",  W.toFixed(1));
    this.svg.setAttribute("height", H.toFixed(1));
    this.svg.setAttribute("viewBox", "0 0 " + W.toFixed(1) + " " + H.toFixed(1));
    this.node.style.width  = W.toFixed(1) + "px";
    this.node.style.height = H.toFixed(1) + "px";

    this.fillPath.setAttribute("d", d);
    this.strokePath.setAttribute("d", d);

    var neckCx = (B1 + B2) / 2;
    this.place(this.slotL, neckCx / 2);
    this.place(this.slotR, (neckCx + W) / 2);
  };

  /* For text-only slots: difference (px) between the line-box centre (font
     metrics, what flex centering uses) and the visual ink centre of the glyphs.
     Positive = ink sits high, so the slot should be nudged down. */
  var _measureCtx = null;
  function opticalYCorrection(slot) {
    if (!slot || slot.children.length) return 0;   // icons/stars: leave as-is
    var text = (slot.textContent || "").trim();
    if (!text) return 0;
    try {
      if (!_measureCtx) _measureCtx = document.createElement("canvas").getContext("2d");
      var cs = getComputedStyle(slot);
      _measureCtx.font = cs.fontWeight + " " + cs.fontSize + " " + cs.fontFamily;
      var m = _measureCtx.measureText(text);
      if (typeof m.actualBoundingBoxAscent !== "number" ||
          typeof m.fontBoundingBoxAscent !== "number") return 0;
      var inkCentre    = (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 2;
      var metricCentre = (m.fontBoundingBoxAscent - m.fontBoundingBoxDescent) / 2;
      return inkCentre - metricCentre;
    } catch (e) { return 0; }
  }

  GooeyDouble.prototype.place = function (slot, cx) {
    if (!slot) return;
    var yOff = this.cssNum("--gd-slot-y", 0) + opticalYCorrection(slot);
    slot.style.position = "absolute";
    slot.style.left = cx.toFixed(1) + "px";
    slot.style.top = "50%";
    slot.style.transform = yOff
      ? "translate(-50%, calc(-50% + " + yOff.toFixed(2) + "px))"
      : "translate(-50%, -50%)";
    slot.style.display = "inline-flex";
    slot.style.alignItems = "center";
    slot.style.whiteSpace = "nowrap";
    slot.style.visibility = "";
  };

  GooeyDouble.prototype.setContent = function (left, right) {
    if (left  != null && this.slotL) this.slotL.innerHTML = left;
    if (right != null && this.slotR) this.slotR.innerHTML = right;
    this.node.removeAttribute("aria-label");
    this.syncAria();
    this.measureAndLayout();
  };

  GooeyDouble._all = [];
  GooeyDouble.upgradeAll = function (selector) {
    var nodes = document.querySelectorAll(selector || ".gooey-double");
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].__gooeyDouble) new GooeyDouble(nodes[i]);
    }
  };
  GooeyDouble.refresh = function () {
    GooeyDouble._all.forEach(function (b) { b.measureAndLayout(); });
  };

  function boot() {
    GooeyDouble.upgradeAll();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(GooeyDouble.refresh);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }

  var rt;
  window.addEventListener("resize", function () {
    clearTimeout(rt); rt = setTimeout(GooeyDouble.refresh, 150);
  });

  global.GooeyDouble = GooeyDouble;
})(window);
